import { createContext, useContext, useState, useEffect } from 'react';

const SchoolContext = createContext(null);

export const useSchool = () => {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchool must be used within SchoolProvider');
  }
  return context;
};

export const SchoolProvider = ({ children }) => {
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load selected school from localStorage
    const saved = localStorage.getItem('selectedSchool');
    if (saved) {
      try {
        setSelectedSchool(JSON.parse(saved));
      } catch (e) {
        localStorage.removeItem('selectedSchool');
      }
    }
    setLoading(false);
  }, []);

  const selectSchool = (school) => {
    setSelectedSchool(school);
    if (school) {
      localStorage.setItem('selectedSchool', JSON.stringify(school));
    } else {
      localStorage.removeItem('selectedSchool');
    }
  };

  const clearSchool = () => {
    setSelectedSchool(null);
    localStorage.removeItem('selectedSchool');
  };

  return (
    <SchoolContext.Provider value={{ selectedSchool, selectSchool, clearSchool, loading }}>
      {children}
    </SchoolContext.Provider>
  );
};
